import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SelfServePinResetAbstractComponent } from '../self-serve-pin-reset.abstract.component';
import { ToastTypes } from '../../../shared/services/abstract/toast.service.abstract';
import { ToastService } from '../../../shared/services/toast.service';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { Observable } from 'rxjs';
import { PinResetService } from '../../../shared/services/pin-reset.service';

@Component({
  selector: 'ziro-self-serve-em-pin-reset',
  templateUrl: '../self-serve-pin-reset.abstract.component.html',
  standalone: false,
})
export class SelfServeEmPinResetComponent extends SelfServePinResetAbstractComponent implements OnInit, OnDestroy {
  private toastService = inject(ToastService);
  private pinResetService = inject(PinResetService);

  ziroIcons = ZiroIcons;

  constructor() {
    super();

    this.headerTranslationKey = 'tkey;self_serve.ext_mobility.header';
    this.headingDataAutomation = 'self-serve-user-details-extension-mobility-header';
  }

  resetPin = (): Observable<void> => {
    return this.pinResetService.resetEndUserPin(
      this.extensionMobilityRef.serverId.toString(),
      this.user,
      this.entity.pin,
      false,
    );
  };

  onPinResetSuccess: (...args: any) => void = (...args: any) => {
    this.onPinResetSuccessBase.call(this, args);

    this.toastService.push(
      ToastTypes.SUCCESS,
      this.ziroIcons.REFRESH,
      'tkey;selfserve.user.resetpin.success.title',
      'tkey;selfserve.user.resetpin.extension_mobility.success.message',
    );
  };
}
